import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Box,
  Button,
  SimpleGrid,
  useColorModeValue
} from "@chakra-ui/react";
import { PessoaType } from "models/person_type";
import FormClient from "views/admin/clients/components/Form";
import useClients from "views/admin/clients/hooks/useClients";
import FormContasReceber from "./components/Form";
import ContasReceberTable from "./components/Table";
import useContasReceber from "./hooks/useContasReceber";
import { ConditionalRenderer } from "views/admin/components/ConditionalRenderer";
import { SimpleConditionalFrame } from "views/admin/components/SimpleConditionalFrame";

const ContasReberScreen = () => {
  const {
    accountSelected,
    add,
    cancelRef,
    changeClient,
    closeDelete,
    closeError,
    deletar,
    edit,
    error,
    errorMsg,
    errorTitle,
    getLink,
    list,
    loadClient,
    loading,
    save,
    selectedClient,
    show,
    showDelete,
    showDeleteModal,
    showError,
    showModal,
    changeInput,
    uploadPictures,
    clients,
    changeFiliais,
    filiais,
    selectedFilial,
    categoria,
    addRowItem,
    deleteRow,
    editRow,
    itemList,
    usuario,
    centroCusto,
    depto,
    selectedCentroCusto,
    selectedDepto,
    changeCentroCusto,
    changeDepto,
    changeCondicaoPagamento,
    condicaoPagamentos,
    selectedCondicaoPagamentos,
    changeConta,
    generateParcela,
    selectedConta,
    contaFinanceiroLista,
    changeUser,
    selectedUser,
    users
  } = useContasReceber();

  const {
    enderecoList,
    showFormPessoa,
    adicionarContato,
    adicionarEndereco,
    bairroRef,
    cargoContatoRef,
    cepRef,
    changeFilial,
    changeItemPessoa,
    cidadeRef,
    classificacaoList,
    classificacaoRef,
    client,
    complementoRef,
    contatoList,
    contribuinteRef,
    deleteContato,
    showPessoa,
    idTipoRef,
    documentoRef,
    razaoSocialRef,
    nomeFantasiaRef,
    inscricaoMunicipalRef,
    inscricaoEstadualRef,
    tipoPessoaList,
    ruaRef,
    numeroRef,
    estadoRef,
    principalRef,
    loadCEP,
    viaCepEnd,
    deleteEnd,
    emailContatoRef,
    principalContatoRef,
    nomeContatoRef,
    filial,
    telefoneContatoRef,
    pessoaFilial,
    nomeClinteRef,
    editPessoa,
    saveCliente,
    errorCliente,
    errorMsgCliente,
    errorTitleCliente,
    cancelPessoaRef,
    closeErrorPessoa,
    contaList,
    bancoRef,
    agenciaRef,
    tipoRef,
    numeroContaRef,
    titularRef,
    tipoPessoaRef,
    documentoContaRef,
    descricaoRef,
    obsRef,
    deleteConta,
    adcionarConta

  } = useClients();

  const editarPessoa = (item: PessoaType) => {
    if (item === undefined || item === null) {
      showError("Erro!", "Selecione o Cliente para editar seus dados!");
    } else {
      editPessoa(item);
    }
  };

  const savePersonData = async () => {
    await saveCliente();
    await loadClient();
  };
  const textColor = useColorModeValue("navy.700", "white");
  const brandStars = useColorModeValue("brand.500", "brand.400");

  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <ConditionalRenderer
        conditions={[
          {
            condition: show,
            component: (
              <SimpleConditionalFrame
                backClick={() => showModal(false)}
                title="Contas a Receber"
              >
                <FormContasReceber
                  accountSelected={accountSelected}
                  brandStars={brandStars}
                  changeCliente={changeClient}
                  changeInput={changeInput}
                  clientes={clients}
                  editPessoa={editarPessoa}
                  getLink={getLink}
                  loading={loading}
                  save={save}
                  selectedCliente={selectedClient}
                  show={show}
                  showFormPessoa={showFormPessoa}
                  showModal={showModal}
                  textColor={textColor}
                  uploadPictures={uploadPictures}
                  changeFiliais={changeFiliais}
                  filiais={filiais}
                  selectedFilial={selectedFilial}
                  categoria={categoria}
                  addRowItem={addRowItem}
                  deleteRow={deleteRow}
                  editRowItem={editRow}
                  itemList={itemList}
                  user={usuario}
                  centroCusto={centroCusto}
                  changeCentroCusto={changeCentroCusto}
                  changeCondicaoPagamento={changeCondicaoPagamento}
                  changeDepto={changeDepto}
                  condicaoPagamento={condicaoPagamentos}
                  depto={depto}
                  selectedCentroCusto={selectedCentroCusto}
                  selectedCondicaoPagamentos={selectedCondicaoPagamentos}
                  selectedDepto={selectedDepto}
                  changeConta={changeConta}
                  contaFinanceiroLista={contaFinanceiroLista}
                  generateParcela={generateParcela}
                  selectedConta={selectedConta}
                  changeUser={changeUser}
                  selectedUser={selectedUser}
                  users={users}
                />
              </SimpleConditionalFrame>
            )
          }
        ]}
        fallback={(
          <SimpleGrid
            mb="20px"
            columns={{ sm: 1, md: 1 }}
            spacing={{ base: "20px", xl: "20px" }}
          >
            <ContasReceberTable
              add={add}
              cancelRef={cancelRef}
              closeDelete={closeDelete}
              deletar={showDeleteModal}
              edit={edit}
              list={list}
              remove={deletar}
              showDelete={showDelete}
            />
          </SimpleGrid>
        )}
      />

      <FormClient
        enderecoList={enderecoList}
        accountSelected={client}
        brandStars={brandStars}
        error={error}
        loading={loading}
        save={savePersonData}
        nomeRef={nomeClinteRef}
        show={showPessoa}
        showModal={showFormPessoa}
        textColor={textColor}
        idTipoRef={idTipoRef}
        classificacaoRef={classificacaoRef}
        documentoRef={documentoRef}
        razaoSocialRef={razaoSocialRef}
        nomeFantasiaRef={nomeFantasiaRef}
        inscricaoMunicipalRef={inscricaoMunicipalRef}
        inscricaoEstadualRef={inscricaoEstadualRef}
        contribuinteRef={contribuinteRef}
        classificacaoList={classificacaoList}
        tipoPessoaList={tipoPessoaList}
        bairroRef={bairroRef}
        cepRef={cepRef}
        ruaRef={ruaRef}
        numeroRef={numeroRef}
        complementoRef={complementoRef}
        cidadeRef={cidadeRef}
        estadoRef={estadoRef}
        principalRef={principalRef}
        loadCEP={loadCEP}
        viaCepEnd={viaCepEnd}
        adicionarEnd={adicionarEndereco}
        deleteEnd={deleteEnd}
        contatoList={contatoList}
        deleteContato={deleteContato}
        adicionarContato={adicionarContato}
        cargoContatoRef={cargoContatoRef}
        emailContatoRef={emailContatoRef}
        nomeContatoRef={nomeContatoRef}
        principalContatoRef={principalContatoRef}
        telefoneContatoRef={telefoneContatoRef}
        changeItem={changeItemPessoa}
        filial={filial}
        changeFilial={changeFilial}
        pessoaFilial={pessoaFilial}
        adcionarConta={adcionarConta}
        agenciaRef={agenciaRef}
        bancoRef={bancoRef}
        contaList={contaList}
        deleteConta={deleteConta}
        descricaoRef={descricaoRef}
        documentoContaRef={documentoContaRef}
        numeroContaRef={numeroContaRef}
        obsRef={obsRef}
        tipoPessoaRef={tipoPessoaRef}
        tipoRef={tipoRef}
        titularRef={titularRef}

      />

      <AlertDialog
        isOpen={error}
        leastDestructiveRef={cancelRef}
        onClose={closeError}
        isCentered
        motionPreset="slideInBottom"
      >
        <AlertDialogOverlay>
          <AlertDialogContent>
            <AlertDialogHeader fontSize="lg" fontWeight="bold">
              {errorTitle}
            </AlertDialogHeader>

            <AlertDialogBody>{errorMsg}</AlertDialogBody>

            <AlertDialogFooter>
              <Button
                ref={cancelRef}
                onClick={closeError}
                colorScheme={"blue"}
              >
                OK
              </Button>
            </AlertDialogFooter>
          </AlertDialogContent>
        </AlertDialogOverlay>
      </AlertDialog>
    </Box>
  );
};
export default ContasReberScreen;
